/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MousePointer2 = [
  "svg",
  defaultAttributes,
  [["path", { d: "m4 4 7.07 17 2.51-7.39L21 11.07z" }]]
];

export { MousePointer2 as default };
//# sourceMappingURL=mouse-pointer-2.js.map
